// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__19JZx","rootCenter":"LoadMoreObserver_rootCenter__2WVeb","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__27V6l"};